<style>

.tabscontentCat {
    flex: 1;
    padding-left: 27px;
}
.middle .tabscontentCat {
    padding-left: 0;
}
.tabcontentCat1{
    flex-direction: column;
}
.tabcontentCat1:first-child{
    display: flex;
    flex: 1;
}
.item_inner {
    display: flex;
    margin-top: 10px;
}
.middle .item_inner {
    flex-wrap: wrap;
}
img.item_image{
    width: 81px;
    height: 81px;
}
.item_descr_large {
    flex: 1;
}
.check {
    display: flex;
    min-width: 128px;
    justify-content: center;
    align-items: center;
    background: #F4F4F4;
    margin-bottom: 12px;
}
.middle .check {
    margin-bottom: 2px;
    min-width: unset;
    flex: 1;
}
.checkContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
}
.checkContainer input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  z-index: 99999;
  height: 14px;
  width: 14px;
}
.checkmark {
  position: absolute;
  height: 14px;
  width: 14px;
  background: #FFFFFF;
  border: 0.5px solid #C4C4C4;
}
.checkContainer:hover input ~ .checkmark {
  background-color: #FFFFFF;
}
.checkContainer input:checked ~ .checkmark {
  background-color: #FFFFFF;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.checkContainer input:checked ~ .checkmark:after {
  display: flex;
}
.checkContainer .checkmark:after {
    left: 4px;
    top: -1px;
    width: 4px;
    height: 9px;
    border: solid #FF0000;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}
.disabled_checkbox {
    opacity: .4;
}
.middle .item_descr {
    width: 100%;
    background: #F4F4F4;
    margin-bottom: 0;
    overflow: hidden;
    height: 0;
    transition: .3s;
}
.middle .item_descr > div {
    padding: 10px;
    font-size: 14px;
    line-height: 13px;
    color: #404455;
}
.middle .item_descr.active {
    height: auto;
}

.item {
    display: flex;
    flex: 1;
    margin-right: 13px;
    background: #F7F6F6;
    margin-bottom: 2px;
    padding: 10px;
}

.middle .item {
    margin-right: unset;
    margin-bottom: 2px;
}

.middle.tabscontentCat {
    padding-left: unset;
}
.item_descr_name {
    padding-bottom: 10px;
    font-size: 14px;
    line-height: 13px;
    color: #404455;
    flex: 1;
}
.item_left_area {
    flex: 1;
    padding-left: 10px;
    justify-content: space-between;
    display: flex;
    flex-direction: column;
}
.addItem {
    width: 20px;
    height: 20px;
    border-radius: 20px;
    background-image: url("./images/cart.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
}
.addItem:hover {
    background-image: url("./images/cart_hover.svg");
}
.item_left_bottom_area {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 20px;
}
.openItemDescription {
    font-size: 14px;
    line-height: 14px;
    color: #404455;
    padding-right: 16px;
    cursor: pointer;
    padding-left: 2px;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    position: relative;
}
.openItemDescription:after {
    content: "";
    display: block;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    background-image: url("./images/big_caret.svg");
    background-position: center;
    background-size: 11px;
    background-repeat: no-repeat;
    width: 11px;
    height: 11px;
    margin-top: 1px;
    transition: .3s;
}
.openItemDescription.open:after {
    transform: translateY(-50%) rotate(180deg);
}
</style>
<script>
    export let items;
    export const index = 0;
    function checkExceptions(i){ return true}
    function checkTabActive(i, j){ return true}
    import { mutations, tabImagesArray, responsiveClass, combinedArray, goodsList, selectedPlusItem, track } from '../../../mainStore.js';
    import helper from '../../../helper.js';
    function getItemImage(item) {
        if (item.prev_image) {
            return item.prev_image
        }
        return getDummy()
    }

    function getDummy() {
        return "/build/images/No Image.png"
    }
    function toggleItem(event, item) {
        try {
            mutations.addItem(item);
            mutations.setShowModal(false)
        } catch (e) {
            mutations.setModalState({
                modalType: null,
                modalState: null,
                modalTitle: "",
                showModal: false,
                item: item,
            })
            mutations.setModalType("alert")
            mutations.setShowModal(true)
            mutations.setModalTitle("")
        }
    }
    function toggle(item) {
        if (item.open) {
            item.open = false
        } else {
            item.open = true
        }
        openRefresh++
    }

    let openRefresh = 0
    let element = []
</script>
<div class="tabscontentCat {$responsiveClass}">
    <div class="tabcontentCat1">
        {#each items as item, i}
            <div class="item_inner">
                <div class="item">
                    <img src="{getItemImage(item)}" alt="" class="item_image">
                    <div class="item_left_area">
                        <div class="item_descr_name">
                            {item.name}
                        </div>
                        <div class="item_left_bottom_area">
                            <div class="addItem" on:click="{(event) => {toggleItem(event, item)}}"></div>
                            {#if (item.description)}
                                <div class="openItemDescription {item.open && openRefresh ? 'open' : ''}" on:click={()=>{toggle(item)}}>Подробнее</div>
                            {/if}
                        </div>
                    </div>
                </div>
                <div class="item_descr" style="{(item.open && openRefresh) ? 'height: '+element[i].offsetHeight+'px' : ''}">
                    <div bind:this={element[i]}>
                        {@html item.description}
                    </div>
                </div>
             </div>
        {/each}

    </div>
</div>
